export default "https://assets.pclncdn.com/web/next-landing/35c697f/_next/static/images/rcBumper-9f864eebd1867e65bb8f5bced2341195.png";